module.exports = __webpack_public_path__ + "img/pw.ecb48bb7.svg";